import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { FrontPage } from '../template/default/pages/front.page';
import { DefaultPage } from '../template/default/pages/default.page';
import { AuthenticatedGuard } from '@naker/naco';
import { DefaultTemplate } from '../template/default/components/default.template';
import { RegisteredGuard } from '@lemsar/auth/guards/registered.guard';
import { LandingPage } from '../views/pages/landing.page';

const routes: Routes = [
    {
        path: '',
        component: FrontPage,
        children: [
            {
                path: '',
                loadChildren: '../../../../src/lemsar/home/home.module#LemsarHomeModule',
            },
        ],
    },
    {
        path: 'home',
        component: DefaultPage,
        children: [
            {
                path: '',
                loadChildren: '../../../../src/lemsar/home/home.module#LemsarHomeModule',
            },
        ],
    },
    {
        path: '',
        component: DefaultTemplate,
        children: [
            {
                path: 'landing',
                canActivate: [AuthenticatedGuard, RegisteredGuard],
                component: LandingPage,
            },
            {
                path: 'dashboards',
                loadChildren: '../../../../src/lemsar/dashboard/dashboard.module#LemsarDashboardModule',
            },
            {
                path: 'institutions',
                loadChildren: '../../../../src/lemsar/institution/institution.module#LemsarInstitutionModule',
            },
            {
                path: 'pre-work-cards',
                loadChildren: '../../../../src/lemsar/pre-work-card/pre-work-card.module#LemsarPreWorkCardModule',
            },
            {
                path: 'jkp',
                loadChildren: '../../../../src/lemsar/jkp/jkp.module#LemsarJkpModule',
            },
            {
                path: 'settings',
                loadChildren: '../../../../src/lemsar/setting/setting.module#LemsarSettingModule',
            },
            {
                path: 'users',
                loadChildren: '../../../../src/lemsar/user/user.module#LemsarUserModule',
            },
        ],
    },
];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// ./apps/frontend/src/bootstrap/app.routes.ts